<template>
<div class="search">
  <div class="row">
    <form @submit.prevent="action" class="col-xs-12 col-md-9">
      <input type="text" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" name="search" id="search" :placeholder="placeholder">
      <input type="submit" value="SUCHE" @click.prevent="action">
    </form>

    <div class="filter col-xs-12 col-md-3" @click="toggleFilter()">
      <input type="text" v-model="filter" name="filter" id="filter" placeholder="Filter/Sortierung" disabled>
      <Icon icon="filter"/>
      <div ref="filter" class="filter__tooltip">
        <div class="filter__tooltip__top">
          <h6>Filter</h6>
          <div class="radios row margin-top--20">
            <div class="col-xs-12 col-sm-6">
              <input type="radio" id="all-services" value="Alle Leistungen" v-model="filter">
              <label for="all-services">Alle Leistungen</label>
            </div>
            <div class="col-xs-12 col-sm-6">
              <input type="radio" id="online-services" value="Nur Online-Leistungen" v-model="filter">
              <label for="online-services">Nur Online-Leistungen</label>
            </div>
          </div>
          <div>
            <label for="authority" class="label margin-top--20 margin-bottom--10">Behörden</label>
            <select name="authority" id="authority">
              <option value="a-all">Alle Behörden</option>
              <option value="a-finance">Finanzamt</option>
              <option value="a-work">Agentur für Arbeit</option>
            </select>
          </div>
        </div>
        <div class="filter__tooltip__bottom">
          <h6>Sortierung</h6>
          <div class="radios row margin-top--10">
            <div class="col-xs-12 col-sm-6">
              <input type="radio" id="sort-alpha" value="Nach Behörden" v-model="sort">
              <label for="sort-alpha">Alphabetisch (A-Z)</label>
            </div>
            <div class="col-xs-12 col-sm-6">
              <input type="radio" id="sort-authority" value="Alphabetisch (A-Z)" v-model="sort">
              <label for="sort-authority">Nach Behörden</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <transition name="tags">
    <div v-if="filter || sort" class="tags margin-top--20">
      <div v-if="filter" class="tag">{{ filter }}<Icon icon="close" @click.native="resetFilter"/></div>
      <div v-if="sort" class="tag">{{ sort }}<Icon icon="close" @click.native="resetSort"/></div>
    </div>
  </transition>
</div>
</template>

<script>
import Icon from '../../components/Icon/Icon';

export default {
  name: 'SearchFilter',
  components: {
    Icon,
  },
  data() {
    return {
      filter: '',
      sort: '',
    }
  },
  props: {
    value: '',
    placeholder: {
      type: String,
      default: ''
    },
    action: {
      type: Function,
      required: true
    }
  },
  methods: {
    toggleFilter() {
      this.$refs.filter.classList.toggle('open');
    },
    resetFilter() {
      console.log('hallo');
      this.filter = '';
    },
    resetSort() {
      this.sort = '';
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./SearchFilter.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/SearchFilter/SearchFilter.vue